import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['togglable']

  static values = {
    initialLineClamp: { type: String, default: 'unset' }
  }

  connect() {
    this.togglableTarget.style.setProperty('-webkit-line-clamp', this.initialLineClampValue)

    if(this.initialLineClampValue != 'unset') {
      this.togglableTarget.style.setProperty('cursor', 'pointer')
    }
  }

  onClick(event) {
    if (event.currentTarget.style.getPropertyValue('-webkit-line-clamp') != 'unset') {
      event.currentTarget.style.setProperty('-webkit-line-clamp', 'unset')
    } else {
      event.currentTarget.style.setProperty('-webkit-line-clamp', this.initialLineClampValue)
    }
  }
}
